import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { useApp } from '@/contexts/AppContext';

const crumbMap: Record<string, string> = {
  '/': 'Dashboard',
  reception: 'Reception',
  'reception/shifts': 'Shifts',
  'reception/checkin': 'Check-in',
  'reception/checkout': 'Check-out',
  'reception/billing': 'Billing & Receipts',
  'reception/cash': 'Cash Tracking',
  'reception/logs': 'Activity Logs',
  'reception/reports': 'Reports',
  bookings: 'Bookings',
  'bookings/rooms': 'Rooms',
  'bookings/new': 'New Booking',
  'bookings/manage': 'Manage Bookings',
  'bookings/guests': 'Guest Directory',
  'bookings/billing': 'GST Billing',
  'bookings/reports': 'Reports',
  inventory: 'Inventory',
  'inventory/stock': 'Stock Levels',
  'inventory/purchases': 'Purchases',
  'inventory/vendors': 'Vendors',
  'inventory/reports': 'Reports',
  canteen: 'Canteen',
  'canteen/menu': 'Menu',
  'canteen/billing': 'Billing & KOT',
  'canteen/history': 'Bill History',
  'canteen/reports': 'Reports',
};

export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  if (pathname === '/') return null;

  const parts = pathname.slice(1).split('/');
  const crumbs: { label: string; path: string }[] = [{ label: 'Dashboard', path: '/' }];

  let path = '';
  for (let i = 0; i < parts.length; i++) {
    path += `/${parts[i]}`;
    const key = parts.slice(0, i + 1).join('/');
    if (crumbMap[key]) {
      crumbs.push({ label: crumbMap[key], path });
    }
  }

  return (
    <div className="flex items-center gap-2 text-sm text-navy-400">
      {crumbs.map((crumb, idx) => (
        <span key={crumb.path} className="flex items-center gap-2">
          {idx > 0 && <i className="ri-arrow-right-s-line text-xs" />}
          {idx === crumbs.length - 1 ? (
            <span className="font-medium text-navy-700">{crumb.label}</span>
          ) : (
            <button
              onClick={() => navigate(crumb.path)}
              className="hover:text-navy-600 cursor-pointer"
            >
              {crumb.label}
            </button>
          )}
        </span>
      ))}
    </div>
  );
}